<template>
  <section class="container brand-film mt-18" v-if="Object.keys(mainVideo).length > 0">
    <div>
      <h1 class="tit"><strong>botalab</strong> Brand Film</h1>
    </div>
    <div class="brand-film--go mt-4">
      <a href="https://www.youtube.com/channel/UCDfIKM3yZL25ZLdUbWQLVcQ" target="_blank">
        <img src="@/assets/images/common/ico_youtube_new.svg" alt="유튜브" />
      </a>
    </div>
    <div class="iframe--wrap">
      <iframe class="brand-film--mv mt-8" :src="`https://www.youtube.com/embed/${mainVideo.youtubeUrl}?rel=0&modestbranding=1`" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BrandFilm',
  props: {
    mainVideo: {
      type: Object,
      defualt: () => {},
    },
  },
};
</script>
